import { DateTime } from 'luxon';

export const getNow = (): DateTime => DateTime.now();
